




























































































































































































































































































































































































































































declare var window: any;
import axios from 'axios';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { UserProfile } from '../../models/userdata/profile';
import WhatsAppConfirmationModal from '../Commons/WhatsAppConfirmationModal.vue';
import RegistrationCard from './Registration/Card.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import {
  NotificationMap,
  NotificationPreferences,
} from '../../models/userdata/notificatonmap';

@Component({
  name: 'NotificationPreference',
  components: {
    AddEntity,
    ProfilePlaceholder,
  },
})
export default class NotificationPreference extends Vue {
  $wlToastr: any;
  private notificationPreferences: NotificationPreferences = new NotificationPreferences();
  private userProfile: UserProfile = new UserProfile();
  private map: string = '';
  private viewMode: boolean = true;
  private userProfileBeforeEdit: UserProfile = new UserProfile();
  private notificationPreferenceBeforeEdit: NotificationPreferences = new NotificationPreferences();
  private previousValue: NotificationMap = new NotificationMap();
  private NOTIFICATION_MAPPERS = {
    SMS : 'SMS',
    PUSH : 'PUSH_NOTIFICATION',
    VOICECALL :'VOICE',
    EMAIL :'EMAIL',
    WHATSAPP : 'WHATSAPP'
  };
  @Prop({ default: () => new Vue(), type: Vue }) bus;

  get canShowMarketingText() {
    return vxm.configs.getGlobalConfigValue('ENABLE_ROLEBASED_REGISTRATION');
  }

  // get showWhatsApp() {
  //   return vxm.configs.whatsappNotificationEnabled;
  // }

  get companyName() {
    return vxm.configs.getGlobalConfigValue('COMPANY_NAME');
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get isProfileDetails() {
    return (
      this.$router.currentRoute.name === 'MyProfileDetails' ||
      this.$router.currentRoute.name === 'NotificationPreference'
    );
  }

  get marketingCheckboxLabel() {
    let checkboxLabel =
      'I would like to receive email communications, including job information, from {APPLICATION_NAME}.';
    if (checkboxLabel && checkboxLabel.includes('{APPLICATION_NAME}')) {
      checkboxLabel = checkboxLabel.replace(
        /{APPLICATION_NAME}/g,
        this.companyName,
      );
    }
    return checkboxLabel;
  }

  isNotificationVisible(key: string) {
    if (
      vxm.configs.IsConfigJSONEnabled &&
      this.notificationPreferences
      // this.userProfile.notificationTypeMap
    ) {
      return vxm.configs.visibilityFieldConfigValue(
        'NOTIFICATION_PREFERENCE',
        'NOTIFICATION_PREFERENCE_' + key,
      );
    }
    else{
        let notificationPreference = vxm.jobs.BrandingInfo.WL_NOTIFICATION_PREFERENCES.split(
          ',',
        );
        return notificationPreference.includes(this.NOTIFICATION_MAPPERS[key]);
    }  
  }

  isEditNotificationVisible() {
    if (
      vxm.configs.IsConfigJSONEnabled &&
      this.notificationPreferences
      // || this.userProfile.notificationTypeMap)
    ) {
      let section = vxm.configs.ClientConfigs.userProfileSections.find(
        (option) => option.sectionKey === 'NOTIFICATION_PREFERENCE',
      );
      if (section && section.fieldConfig) {
        let visibilitySections = section.fieldConfig.filter((field) => {
          return field.visibility;
        });
        return visibilitySections.length > 0 ? true : false;
      }
      return true;
    }
    return true;
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'NOTIFICATION_PREFERENCE',
      );
      return section ? section.displayName : 'Notification Preferences';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'NOTIFICATION_PREFERENCE',
    );
    return section ? section.displayName : 'Notification Preferences ';
  }

  async showEditProfilePage() {
    this.previousValue = { ...vxm.users.myUserProfile.notificationTypeMap };
    this.viewMode = false;
  }

  async mounted() {
    this.notificationPreferences = await vxm.notificationpreference.geUserNotificationPreferences();
    this.notificationPreferenceBeforeEdit = Object.assign(this.notificationPreferenceBeforeEdit,this.notificationPreferences);
    // this.userProfile = vxm.users.myUserProfile;
    // this.userProfileBeforeEdit = Object.assign({}, this.userProfile);
  }

  changeState() {
    if (this.notificationPreferences.whatsapp) {
      this.$modal.show(
        WhatsAppConfirmationModal,
        {
          body: 'I agree to receive important information and updates over',
          onCancel: this.cancelToggleChanges,
          okText: 'Agree',
          cancelText: 'Cancel',
        },
        {
          height: 'auto',
          clickToClose: false,
        },
      );
    }
  }

  cancelToggleChanges() {
    // this.userProfile.notificationTypeMap.WHATSAPP = !vxm.users.myUserProfile
    // .notificationTypeMap.WHATSAPP;
    this.notificationPreferences.whatsapp = false;
  }

  async saveUserProfile() {
    const vm = this;
    const jwtToken = vxm.users.getToken;
    const token = 'Bearer ' + jwtToken;
    const respPromise = await vxm.notificationpreference.updateUserNotificationPreferences(
      this.notificationPreferences,
    );
    // const respPromise: any = vxm.users.saveUserProfile({
    //   userProfile: this.userProfile,
    //   isPartofRegistration: false,
    // });
    console.log(
      'respPromise .... after saving notification preference',
      respPromise,
    );
    Promise.all([respPromise]).then((values) => {
      console.log(
        'values[0].data.success',
        values[0].data.meta.success,
        'values[0].data',
        values[0].data,
        'values[0]',
        values[0],
      );
      if (!values[0].data.meta.success) {
        vm.$wlToastr(
          'error',
          vm.$t('notificationpreference.update.error'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
      } else {
        vm.$wlToastr(
          'success',
          vm.$t('notificationpreference.update.sucess'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
      }
    });
  }

  async cancelChanges() {
    // Object.assign(this.userProfile, this.userProfileBeforeEdit);
    // vxm.users.myUserProfile.notificationTypeMap = { ...this.previousValue };
    Object.assign(this.notificationPreferences , this.notificationPreferenceBeforeEdit);
    this.viewMode = true;
  }

  updateChanges() {
    this.saveUserProfile();
    this.viewMode = true;
  }
}
